import axiosRequest from "./axiosRequest";
import API from "./api";
import Vue from "vue";
const REDIRECT_PATHS = {
    CREATE: `/pages/redirect/create`,
    MAP: `/pages/redirect/map`,
    HISTORY: `/pages/redirect/history`,
    ALERT: `/pages/redirect/alert`,
}
async function generatePath(productId, companyId,preProductId) {
    let data = await axiosRequest({
        url: API.getProductById,
        method: 'POST',
        data: {
            id: productId,  // 页面id
            companyId: companyId
        },
        header: API.header,
    });
    data = data[1].data.product;
    console.log(data);
    let prefix;
    switch (data.product_type) {
        case 0: {
            console.log("第一第一第一第一");
            prefix = REDIRECT_PATHS.CREATE;
            break;
        }
        case 1: {
            prefix = REDIRECT_PATHS.MAP;
            break;
        }
        case 2: {
            prefix = REDIRECT_PATHS.ALERT;
            break;
        }
        case 3: {
            prefix = REDIRECT_PATHS.HISTORY;
            break;
        }
    }
    console.log("我看看",preProductId)
    if (preProductId) {
        console.log("我看看",preProductId)
        return `${Vue.prototype.$REDIRECT_PREFIX}${prefix}?read_only=true&projectId=${data.projectId}&productId=${data.id}&authorId=${data.authorId}&companyId=${data.companyId}&preProductId=${preProductId}`;
    }else{
        console.log("这里")
        return `${Vue.prototype.$REDIRECT_PREFIX}${prefix}?read_only=true&projectId=${data.projectId}&productId=${data.id}&authorId=${data.authorId}&companyId=${data.companyId}`;
    }
}

function handleRedirect(url){
    window.open(url, "_blank", "height=1000, width=1600, top=100, left=100,toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
}
export {generatePath, handleRedirect}